import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { Code, CodeDTO } from "./code";


export namespace NotApplicableOptionV1 {
  export interface ShownDTO {
    case: string;
    naOptionText: SurveyLocalizedTextDTO;
    naOptionCode: CodeDTO;
  }
  
  export class Shown {
    readonly isNotApplicableOptionV1Shown: boolean = true;
  
    readonly naOptionText: SurveyLocalizedText;
    readonly naOptionCode: Code;
  
  
    constructor(
    naOptionText: SurveyLocalizedText, 
    naOptionCode: Code
    ) {
      this.naOptionText = naOptionText;
      this.naOptionCode = naOptionCode;
    }
  
    static fromDTO(dto: ShownDTO): Shown {
      const naOptionText = SurveyLocalizedText.fromDTO(getObject(dto, "naOptionText", InvalidNotApplicableOptionV1ShownNaOptionTextError));
      const naOptionCode = Code.fromDTO(getObject(dto, "naOptionCode", InvalidNotApplicableOptionV1ShownNaOptionCodeError));
      return new Shown(
        naOptionText,
        naOptionCode
      );
    }
  
    toDTO(): ShownDTO {
      const dto: ShownDTO = {
        case: "SHOWN",
          naOptionText: this.naOptionText.toDTO(),
          naOptionCode: this.naOptionCode.toDTO()
      };
      return dto;
    }
    }
  
  Shown.prototype.toString = function toString(): string {
    return `NotApplicableOptionV1.SHOWN(naOptionText='${this.naOptionText}',naOptionCode='${this.naOptionCode}')`;
  };
  
  export interface HiddenDTO {
    case: string;
  }
  
  export class Hidden {
    readonly isNotApplicableOptionV1Hidden: boolean = true;
  
  
  
  
  
    toDTO(): HiddenDTO {
      const dto: HiddenDTO = {
        case: "HIDDEN",
      };
      return dto;
    }
    }
  
  Hidden.prototype.toString = function toString(): string {
    return `NotApplicableOptionV1.HIDDEN()`;
  };
  

  export type NotApplicableOptionV1 = Shown | Hidden;

  export type NotApplicableOptionV1DTO = ShownDTO | HiddenDTO;

  export const fromDTO = (dto: NotApplicableOptionV1DTO): NotApplicableOptionV1 => {
    switch (dto.case) {
      case "SHOWN":
          return Shown.fromDTO(dto as ShownDTO);
      case "HIDDEN":
          return new Hidden();
      default:
        throw new InvalidNotApplicableOptionV1Error(
            `Case ${dto.case} is not valid case of NotApplicableOptionV1.`
        );
    }
  };
}

export class InvalidNotApplicableOptionV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidNotApplicableOptionV1Error";
  }
}
export class InvalidNotApplicableOptionV1ShownError extends InvalidNotApplicableOptionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidNotApplicableOptionV1ShownError";
  }
}

export class InvalidNotApplicableOptionV1ShownNaOptionTextError extends InvalidNotApplicableOptionV1ShownError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidNotApplicableOptionV1ShownNaOptionTextError";
  }
}

export class InvalidNotApplicableOptionV1ShownNaOptionCodeError extends InvalidNotApplicableOptionV1ShownError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidNotApplicableOptionV1ShownNaOptionCodeError";
  }
}

export class InvalidNotApplicableOptionV1HiddenError extends InvalidNotApplicableOptionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidNotApplicableOptionV1HiddenError";
  }
}
